function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelescopeSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EFC84A"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M511.92,258.069c-1.013,127.733-95.52,233.12-218.453,251.147 L168.453,384.203c-2.72-1.12-4-4.267-2.827-6.987l21.333-50.24l-67.947-67.947l-9.707-39.147l14.933-3.68l0.8,3.2l52.48-12.96 l-3.2-12.8l14.933-3.733l52.427-12.907l-1.973-8.053l16.16-4l96.907-23.947l-1.547-6.24l29.973-7.413L511.92,258.069z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A556A"
    },
    d: "M288.587,384.645c-2.075,0-4.048-1.221-4.907-3.248l-54.128-127.376l-54.128,127.376 c-1.152,2.715-4.309,3.979-6.992,2.821c-2.715-1.152-3.979-4.283-2.821-6.992l59.035-138.928c0.832-1.973,2.768-3.248,4.907-3.248 c2.139,0,4.075,1.275,4.907,3.248l59.035,138.928c1.157,2.709-0.112,5.84-2.821,6.992 C289.995,384.512,289.285,384.645,288.587,384.645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A556A"
    },
    d: "M229.552,375.643c-2.949,0-5.333-2.384-5.333-5.333v-129.92c0-2.949,2.384-5.333,5.333-5.333 s5.333,2.384,5.333,5.333v129.92C234.885,373.253,232.501,375.643,229.552,375.643z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.582,
    y: 129.742,
    transform: "matrix(0.9708 -0.2398 0.2398 0.9708 -30.8575 95.4985)",
    style: {
      fill: "#3A556A"
    },
    width: 30.826,
    height: 89.614
  })), /*#__PURE__*/React.createElement("rect", {
    x: 263.623,
    y: 151.86,
    transform: "matrix(-0.9708 0.2398 -0.2398 -0.9708 663.5555 299.7036)",
    style: {
      fill: "#EBF0F3"
    },
    width: 99.843,
    height: 76.724
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.703,
    y: 165.819,
    transform: "matrix(0.9708 -0.2398 0.2398 0.9708 -41.4643 67.5913)",
    style: {
      fill: "#E56353"
    },
    width: 16.624,
    height: 76.724
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.681,
    y: 182.558,
    transform: "matrix(-0.9708 0.2398 -0.2398 -0.9708 489.8801 365.6512)",
    style: {
      fill: "#EBF0F3"
    },
    width: 54.026,
    height: 60.143
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.325,
    y: 190.919,
    transform: "matrix(0.9708 -0.2398 0.2398 0.9708 -47.4795 51.7744)",
    style: {
      fill: "#E56353"
    },
    width: 15.376,
    height: 60.143
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.317,
    y: 212.44,
    transform: "matrix(-0.9708 0.2398 -0.2398 -0.9708 361.1109 414.6361)",
    style: {
      fill: "#EBF0F3"
    },
    width: 54.025,
    height: 33.695
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 113.958,
    y: 217.451,
    transform: "matrix(0.9708 -0.2398 0.2398 0.9708 -53.4365 36.1051)",
    style: {
      fill: "#64798A"
    },
    width: 15.376,
    height: 40.367
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#64798A"
    },
    cx: 229.547,
    cy: 240.373,
    r: 18.997
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#2F4859"
    },
    cx: 229.547,
    cy: 240.373,
    r: 10.459
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelescopeSvgrepoCom);
export default __webpack_public_path__ + "static/media/telescope-svgrepo-com.bd0a8f50f18ae5e684a0b8d3c0f2e85a.svg";
export { ForwardRef as ReactComponent };